<div class="container-fluid h-100 readOnlyForm pl-0 pr-0">
  <!-- Section header start -->
  <div class="headerBackground card p-1 mb-2 tool-header-height">
    <div class="row padding2px">
      <div class="col col-1 col-md-1 col-lg-1 col-sm-1 col-xs-1 sectionHeaderIcon">
        <span *ngIf="dashBoardName == 'Execution Dashboard'">
          <!-- <fa-icon class="fas checklistIcon"  [icon]="faCircle">
          </fa-icon> -->
          <fa-icon class="fas fa-lg autoCursor" title="click for smart checklist" (click)="openSmartChecklist()"  [icon]="faTachometerAlt"></fa-icon>
        </span>

      </div>
      <div class="col col-3 col-md-3 col-lg-3 col-sm-3 col-xs-4">

        <h6 class="headerFontSize" *ngIf="dashBoardName == 'Execution Dashboard'">
          {{ 'menu.execdashboard' | translate }}</h6>



      </div>
      <div class="col col-7 col-md-7 col-lg-7 col-sm-7 col-xs-6">

        <p class="titleParagraph" *ngIf="dashBoardName == 'Execution Dashboard'">
          {{'executionDashboard.toolHeaderLine1' | translate}}<br>
          {{'executionDashboard.toolHeaderLine2' | translate}}
        </p>

      </div>
      <div class="col col-1 col-md-1 col-lg-1 col-sm-1 col-xs-1">
        <div class="dropGroupBtn marginbottom5px">

          <span *ngIf="dashBoardName == 'Execution Dashboard'">
            <a type="button" class="" data-toggle="modal" data-target="#ytVideoLinkDED">
              <fa-icon class="fas fa-lg" [icon]="faInfoCircle" title="help"></fa-icon>
            </a>
          </span>

        </div>
      </div>
    </div>
  </div>
  <!-- Section header end -->

  <div class="dashboard tool-body-height">
    <div class="card p-1 mb-2 bg-white h-100">
      <div class="row">
        <div class="col-md-12">
          <div style="width: 100%;">
            <!-- <canvas id="dependencyWheel" width="300" height="500" #dependencyWheel></canvas> -->
          </div>
        </div>
        </div>
      <div class="dash-board-overview-height">
        <div class="row full-width only-bottom-padding h-50 card p-1 bg-white">
          <div class="table-responsive dash-board-level-table-height">
            <table width="100%" border="0" cellspacing="0" cellpadding="0"
              class="table table-bordered border-none table-xs d-board tableBackgrdClrBlack menuItemsClrBlack">
              <tbody>
                <tr *ngFor="let p of model.dashboardsUI[model.db][model.eutType]; let tabIndex = index"
                  [ngClass]="{dis:p.name==''}">
                  <th class="border-left1px menuItemsClrWhite">
                    {{p.name.level}}
                  </th>
                  <th class="menuItemsClrWhite">
                    <span data-toggle="tooltip" title="{{p.name.name}}" data-placement="right">
                      {{p.name.symbol}}
                    </span>
                  </th>
                  <td *ngFor="let eut of p.eutList; let tabIndex = index">
                    <span class="dashboardPopover"
                      [ngClass]="{displayNone:((eut.count.total==0)||(eut.count.total==-1))}">
                      <a tabindex="0" data-trigger="focus" autocomplete="off" data-html="true" role="button"
                        data-toggle="popover" data-placement="left"
                        title="Total:{{eut.count.total}} <br> Positive:{{eut.count.positive}} <br> Negative:{{eut.count.negative}}">
                        <span class="menuItemsClrWhite">
                          {{eut.count.total}}
                          <span>%</span>
                        </span>
                      </a>
                    </span>
                  </td>
                  <td class="sum-row bg-color-black menuItemsClrBlack">
                    <span class="dashboardPopover">
                      <a class="text-color-white" tabindex="0" data-placement="left" data-html="true"
                        data-toggle="popover" data-trigger="focus" role="button"
                        title="Total:{{p.test.total}} <br /> Positive:{{p.test.positive}} <br/> Negative:{{p.test.negative}} ">
                        <span class="textClrYellow">
                          {{p.test.total}}
                          <span>%</span>
                        </span>
                      </a>
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="table-nonresponsive i-mapper-table dashboard-ESD-pr-0">
            <table width="100%" border="0" cellspacing="0" cellpadding="0"
              class="table table-bordered border-none table-xs tableBackgrdClrBlack">
              <tbody>
                <tr [ngClass]="{displayNone:model.totalOfDashboardUI[model.db][model.eutType].length==tabIndex+1}"
                  *ngFor="let p of model.totalOfDashboardUI[model.db][model.eutType]; let tabIndex = index">
                  <th class="border-left1px">
                  </th>
                  <th>
                  </th>
                  <td class="sum-row bg-color-black fontsize8pxESD menuItemsClrBlack"
                    *ngFor="let eut of p.eutListTotal; let tabIndex = index" [ngClass]="{dis:eut.count.total==-1}">
                    <span class="dashboardPopover" *ngIf="eut.count.total!=-1">
                      <span *ngIf="tabIndex != 15" class="text-color-white" tabindex="0" data-html="true" role="button"
                        data-toggle="popover" data-trigger="focus"
                        title=" Total : {{eut.count.total}} <br />  Positive:{{eut.count.positive}} <br />  Negative:{{eut.count.negative}} ">
                        <span class="textClrYellow">
                          {{eut.count.total}}
                          <span>%</span>
                        </span>
                      </span>
                      <span *ngIf="tabIndex == 15" class="text-color-white" tabindex="0" data-html="true" role="button"
                        data-toggle="popover" data-trigger="focus" data-placement="left"
                        title=" Total : {{eut.count.total}} <br />  Positive:{{eut.count.positive}} <br />  Negative:{{eut.count.negative}} ">
                        <span class="textClrYellow">
                          {{eut.count.total}}
                          <span>%</span>
                        </span>
                      </span>
                    </span>
                  </td>
                </tr>
                <tr [ngClass]="{displayNone:model.totalOfDashboardUI[model.db][model.eutType].length!=tabIndex+1}"
                  *ngFor="let p of model.totalOfDashboardUI[model.db][model.eutType]; let tabIndex = index">
                  <th class="border-left1px">
                  </th>
                  <th>
                  </th>
                  <td class="fontsize8pxESD" *ngFor="let eut of p.eutListTotal; let tabIndex = index"
                    [ngClass]="{dis:eut.count.total==-1||eut.count.total!=''}">
                    <span class="dashboardPopover" *ngIf="eut.count.total!=0">
                      <a class="text-color-black" tabindex="0" data-html="true" role="button" data-toggle="popover"
                        data-trigger="focus"
                        title="Total : {{eut.count.total}} <br /> Positive:{{eut.count.positive}} <br /> Negative:{{eut.count.negative}} ">
                        {{eut.count.total}}
                      </a>
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

        </div>
        <div class="row strict h-50 card p-1 mb-2 bg-white menuItemsClrWhite">
          <div class="row strict">
            <ul class="nav nav-tabs">
              <li class="active">
                <a data-toggle="tab" ng-attr-data-target="#fe1234" (click)="setEUTtypeChosen('TF')">
                  {{ 'entities.Fe' | translate }}&nbsp;
                  ({{(modelData.listOfEUTs|landscaperEntity:{eType:'TF'}:filterTypeCount)}})
                </a>
              </li>
              <li>
                <a data-toggle="tab" ng-attr-data-target="#ur1234" (click)="setEUTtypeChosen('UR')">
                  {{ 'entities.Ur' | translate }}&nbsp;
                  ({{(modelData.listOfEUTs|landscaperEntity:{eType:'UR'}:filterTypeCount)}})
                </a>
              </li>
              <li>
                <a data-toggle="tab" ng-attr-data-target="#bf1234" (click)="setEUTtypeChosen('BF')">
                  {{ 'entities.Bf' | translate }}&nbsp;
                  ({{(modelData.listOfEUTs|landscaperEntity:{eType:'BF'}:filterTypeCount)}})
                </a>
              </li>
              <li>
                <a data-toggle="tab" ng-attr-data-target="#xx1234" (click)="setEUTtypeChosen('XX')">
                  {{ 'entities.Xx' | translate }}&nbsp;
                  ({{(modelData.listOfEUTs|landscaperEntity:{eType:'XX'}:filterTypeCount)}})
                </a>
              </li>
            </ul>
          </div>
          <div class="tab-content dash-board-nav-tab-table-height dashboardBottomTable table-bordered">
            <div ng-attr-id="fe1234" class="tab-pane fade in active h-100 overflowYTextAuto">
              <ul class="alert-height list-group h-100 mb-0" *ngIf="!entityExists(model.eutType)" class="list-group">
                <div class="alert alert-warning mb-0">
                  <strong>
                    <div style="text-align: center;">
                      {{ 'emptyEntitiesErrors.Fe' | translate }}
                    </div>
                  </strong>
                </div>
              </ul>
              <table class="table env1 h-100 mb-0 tableBackgrdClrBlack" *ngIf="entityExists(model.eutType)">
                <thead class="" *ngIf="entityExists(model.eutType)">
                  <tr class=" row strict border-bottom1px">
                    <th class="col-xs-1 border-right1px border-left1px">
                      <div style="text-align: center;">
                        <input class="checkboxReadOnly" type="checkbox" [checked]="isAllSelected()"
                          (click)="toggleAllDeselect($event.target.checked)">
                      </div>
                    </th>
                    <th class="col-xs-1 border-right1px">#</th>
                    <th class="col-xs-10">{{ 'entities.nameOfEntity' | translate }}</th>
                  </tr>
                </thead>
                <tbody class="toolEntityTBody">
                  <tr class=" row strict border-bottom1px" *ngFor="let eut of pagedItems; let tabIndex = index">
                    <td class="col-xs-1 border-bottom1px border-right1px border-left1px">
                      <div style="text-align: center;">
                        <input class="checkboxReadOnly" type="checkbox" [checked]="isChecked(eut.eID)"
                          (click)="toggleSelection(eut.eID)">
                      </div>
                    </td>
                    <td class="col-xs-1 border-bottom1px border-right1px">
                      {{eutCollection[model.eutType].indexOf(eut)+1}}
                    </td>
                    <td class="col-xs-10 border-bottom1px border-right1px"> {{getModuleName(eut)}}  | {{eut.eName}}</td>
                  </tr>
                </tbody>
              </table>

            </div>
            <div ng-attr-id="ur1234" class="tab-pane fade in h-100 overflowYTextAuto">
              <ul class="alert-height list-group h-100 mb-0" *ngIf="!entityExists(model.eutType)" class="list-group">
                <div class="alert alert-warning mb-0">
                  <strong>
                    <div style="text-align: center;">
                      {{ 'emptyEntitiesErrors.Ur' | translate }}
                    </div>
                  </strong>
                </div>
              </ul>

              <table class="table env1 h-100 mb-0 tableBackgrdClrBlack" *ngIf="entityExists(model.eutType)">
                <thead class="" *ngIf="entityExists(model.eutType)">
                  <tr class="row strict border-bottom1px">
                    <th class="col-xs-1 border-right1px">
                      <div style="text-align: center;">
                        <input class="checkboxReadOnly" type="checkbox" [checked]="isAllSelected()"
                          (click)="toggleAllDeselect($event.target.checked)">
                      </div>
                    </th>
                    <th class="col-xs-1 border-right1px">#</th>
                    <th class="col-xs-10">{{ 'entities.nameOfEntity' | translate }}</th>
                  </tr>
                </thead>
                <tbody class="toolEntityTBody">
                  <tr class="row strict border-bottom1px border-right1px"
                    *ngFor="let eut of pagedItems; let tabIndex = index">
                    <td class="col-xs-1 border-bottom1px border-right1px">
                      <div style="text-align: center;">
                        <input class="checkboxReadOnly" type="checkbox" [checked]="isChecked(eut.eID)"
                          (click)="toggleSelection(eut.eID)">
                      </div>
                    </td>
                    <td class="col-xs-1 border-bottom1px border-right1px">
                      {{eutCollection[model.eutType].indexOf(eut)+1}}
                    </td>
                    <td class="col-xs-10 border-bottom1px border-right1px"> {{getModuleName(eut)}}  | {{eut.eName}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div ng-attr-id="bf1234" class="tab-pane fade in h-100 overflowYTextAuto">
              <ul class="alert-height list-group h-100 mb-0" *ngIf="!entityExists(model.eutType)" class="list-group">
                <div class="alert alert-warning mb-0">
                  <strong>
                    <div style="text-align: center;">
                      {{ 'emptyEntitiesErrors.Bf' | translate }}
                    </div>
                  </strong>
                </div>
              </ul>

              <table class="table env1 h-100 mb-0 tableBackgrdClrBlack" *ngIf="entityExists(model.eutType)">
                <thead class="" *ngIf="entityExists(model.eutType)">
                  <tr class=" row strict border-bottom1px">
                    <th class="col-xs-1 border-right1px">
                      <div style="text-align: center;">
                        <input class="checkboxReadOnly" type="checkbox" [checked]="isAllSelected()"
                          (click)="toggleAllDeselect($event.target.checked)">
                      </div>
                    </th>
                    <th class="col-xs-1 border-right1px">#</th>
                    <th class="col-xs-10">{{ 'entities.nameOfEntity' | translate }}</th>
                  </tr>
                </thead>
                <tbody class="toolEntityTBody">
                  <tr class=" row strict border-bottom1px border-right1px"
                    *ngFor="let eut of pagedItems ; let tabIndex = index">

                    <td class="col-xs-1 border-bottom1px border-right1px">
                      <div style="text-align: center;">
                        <input class="checkboxReadOnly" type="checkbox" [checked]="isChecked(eut.eID)"
                          (click)="toggleSelection(eut.eID)">
                      </div>
                    </td>
                    <td class="col-xs-1 border-bottom1px border-right1px">
                      {{eutCollection[model.eutType].indexOf(eut)+1}}
                    </td>
                    <td class="col-xs-10 border-bottom1px border-right1px"> {{getModuleName(eut)}}  | {{eut.eName}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div ng-attr-id="xx1234" class="tab-pane fade in h-100 overflowYTextAuto">
              <ul class="alert-height list-group h-100 mb-0" *ngIf="!entityExists(model.eutType)" class="list-group">
                <div class="alert alert-warning mb-0">
                  <strong>
                    <div style="text-align: center;">
                      {{ 'emptyEntitiesErrors.Xx' | translate }}
                    </div>
                  </strong>
                </div>
              </ul>

              <table class="table env1 h-100 mb-0 tableBackgrdClrBlack" *ngIf="entityExists(model.eutType)">
                <thead class="" *ngIf="entityExists(model.eutType)">
                  <tr class=" row strict border-bottom1px">
                    <th class="col-xs-1 border-right1px">
                      <div style="text-align: center;">
                        <input class="checkboxReadOnly" type="checkbox" [checked]="isAllSelected()"
                          (click)="toggleAllDeselect($event.target.checked)">
                      </div>
                    </th>
                    <th class="col-xs-1 border-right1px">#</th>
                    <th class="col-xs-10">{{ 'entities.nameOfEntity' | translate }}</th>
                  </tr>
                </thead>
                <tbody class="toolEntityTBody">
                  <tr class=" row strict border-bottom1px border-right1px"
                    *ngFor="let eut of pagedItems ; let tabIndex = index">

                    <td class="col-xs-1 border-bottom1px border-right1px">
                      <div style="text-align: center;">
                        <input class="checkboxReadOnly" type="checkbox" [checked]="isChecked(eut.eID)"
                          (click)="toggleSelection(eut.eID)">
                      </div>
                    </td>
                    <td class="col-xs-1 border-bottom1px border-right1px">
                      {{eutCollection[model.eutType].indexOf(eut)+1}}
                    </td>
                    <td class="col-xs-10 border-bottom1px border-right1px"> {{getModuleName(eut)}}  | {{eut.eName}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <div class="row entity-row">
        <div style="text-align: center;">
          <div class="btn-group" role="group">
            <button class="btn btn-sm btn-default" [ngClass]="{ dis: !disableUp }" (click)="firstPage();setPage(1)">
              <fa-icon class="fa menuItemsClrBlack" [icon]="faStepBackward"></fa-icon>
            </button>
            <button class="btn btn-sm btn-default" [ngClass]="{ dis: !disableUp }"
              (click)="previousPage();setPage(pager.currentPage - 1)">
              <fa-icon class="fa menuItemsClrBlack" [icon]="faAngleLeft"></fa-icon>
            </button>
            <button class="btn btn-sm btn-default" [ngClass]="{ dis: !disableDown }"
              (click)="nextPage();setPage(pager.currentPage + 1)">
              <fa-icon class="fa menuItemsClrBlack" [icon]="faAngleRight"></fa-icon>
            </button>
            <button class="btn btn-sm btn-default" [ngClass]="{ dis: !disableDown }"
              (click)="lastPage();setPage(pager.totalPages)">
              <fa-icon class="fa menuItemsClrBlack" [icon]="faStepForward"></fa-icon>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Section footer start -->
  <div class="headerBackground card p-1 mt-2 tool-footer-height">
    <div class='row pb-0 pt-0'>
      <div id="dashboardTip" class="carousel slide" data-ride="carousel" data-interval="false">
        <div class="carousel-inner text-color-yellow">
          <div class="row item active text-color-yellow">

            <div class="col-xs-12 align_center carousel-tip-align" *ngIf="dashBoardName == 'Execution Dashboard'">
              Tip #1 : {{'executionDashboard.tip1' | translate}}
            </div>

          </div>
          <div class="row item text-color-yellow">

            <div class="col-xs-12 align_center carousel-tip-align" *ngIf="dashBoardName == 'Execution Dashboard'">
              Tip #2 : {{'executionDashboard.tip2' | translate}}
            </div>

          </div>
          <div class="row item text-color-yellow ">

            <div class="col-xs-12 align_center carousel-tip-align" *ngIf="dashBoardName == 'Execution Dashboard'">
              Tip #3 : {{'executionDashboard.tip3' | translate}}
            </div>

          </div>
        </div>
        <a class="left carousel-control carousel-tip-align display-flex" data-target="#dashboardTip" data-slide="prev">
          <span>
            <fa-icon class="fas" [icon]="faChevronLeft"></fa-icon>
          </span>
          <span class="sr-only">Previous</span>
        </a>
        <a class="right carousel-control carousel-tip-align display-flex" data-target="#dashboardTip" data-slide="next">
          <span>
            <fa-icon class="fas" [icon]="faChevronRight"></fa-icon>
          </span>
          <span class="sr-only">Next</span>
        </a>
      </div>
    </div>
  </div>
  <!-- Section footer end -->


  <!-- Youtube video Modal -->
  <div class="modal fade bd-example-modal-lg" id="ytVideoLinkDED" tabindex="-1" role="dialog"
    aria-labelledby="ytVideoLinkDED" aria-hidden="true">
    <div class="vertical-alignment-helper">
      <div class="modal-dialog vertical-align-center">
        <div class="modal-content ytVideoLink">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" (click)="terminateVideo()"
              aria-hidden="true">&times;</button>
            <h4 class="modal-title" id="myModalLabel">{{'youtubeVideoTitle.executiondashboard' | translate}}</h4>
          </div>
          <!-- Modal body -->
          <div class="modal-body">
            <iframe width="100%" height="100%" class="youtubeVideo" id="testExecutionQualityVideoLink" frameborder="0"
              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
          </div>
        </div>
      </div>
    </div>
  </div>




</div>